import "./Switch.css";

/**
 * Interruptor de encendido y apagado.
 *
 * Es un <button> con role="switch" y no un <input type="checkbox">
 * disfrazado: asi el lector de pantalla anuncia "activado / desactivado" en
 * vez de "casilla marcada", que es lo que esto significa de verdad.
 *
 * El estado no se dibuja solo con el color: al lado va el texto (Active /
 * Inactive, Published / Not published). Un switch que solo cambia de color
 * no dice nada a quien no distingue verde de gris.
 *
 * Props:
 *   activo      encendido o apagado
 *   onChange    recibe el valor NUEVO, no el evento
 *   etiqueta    el nombre de lo que controla
 *   textoOn     y textoOff: lo que se lee al lado del interruptor
 *   ayuda       una linea abajo explicando que hace, opcional
 *   ocupado     mientras se guarda: bloquea y baja la opacidad
 */
function Switch({
  activo,
  onChange,
  etiqueta,
  textoOn = "On",
  textoOff = "Off",
  ayuda,
  ocupado = false,
  disabled = false,
}) {
  const bloqueado = disabled || ocupado;

  return (
    <div className={`sw ${bloqueado ? "sw--off" : ""}`}>
      <div className="sw-fila">
        <button
          type="button"
          role="switch"
          aria-checked={activo}
          aria-label={etiqueta}
          className={`sw-pista ${activo ? "sw-pista--on" : ""}`}
          onClick={() => !bloqueado && onChange(!activo)}
          disabled={bloqueado}
        >
          <span className="sw-bolita" />
        </button>

        <div className="sw-textos">
          <span className="sw-etiqueta">{etiqueta}</span>
          <span className={`sw-estado ${activo ? "sw-estado--on" : ""}`}>
            {ocupado ? "Saving..." : activo ? textoOn : textoOff}
          </span>
        </div>
      </div>

      {ayuda ? <p className="sw-ayuda">{ayuda}</p> : null}
    </div>
  );
}

export default Switch;
